import type { IconNode } from '../types';

/**
 * @name can-soda
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTcgMjIgMS42NjQtMi40OTZhMiAyIDAgMDAuMzM2LTEuMTFWNS42MDZhMiAyIDAgMDAtLjMzNi0xLjExTDE3IDIiIC8+CiAgPHBhdGggZD0iTTE4IDIySDYiIC8+CiAgPHBhdGggZD0iTTE4IDJINiIgLz4KICA8cGF0aCBkPSJNNSAxN2gxNCIgLz4KICA8cGF0aCBkPSJNNSA3aDE0IiAvPgogIDxwYXRoIGQ9Im03IDIyLTEuNjY0LTIuNDk2QTIgMiAwIDAxNSAxOC4zOTRWNS42MDZhMiAyIDAgMDEuMzM2LTEuMTFMNyAyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/can-soda
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CanSoda: IconNode = [
  ['path', { d: 'm17 22 1.664-2.496a2 2 0 00.336-1.11V5.606a2 2 0 00-.336-1.11L17 2' }],
  ['path', { d: 'M18 22H6' }],
  ['path', { d: 'M18 2H6' }],
  ['path', { d: 'M5 17h14' }],
  ['path', { d: 'M5 7h14' }],
  ['path', { d: 'm7 22-1.664-2.496A2 2 0 015 18.394V5.606a2 2 0 01.336-1.11L7 2' }],
];

export default CanSoda;
